export default __webpack_public_path__ + "4e5f298086a491d8a1ba722018ec7117.svg";